module.exports = {
	SET_GEOLOCATION:'SET_GEOLOCATION'
}
